const Round = (value) => {
	try {
		return value === 0 ? 0 : value ? Math.round(value) : null;
	} catch (e) {
		console.log(e);
	}
};

export default Round;
